<template>
  <div class="card">
    <div class="card-header">
      <h5>{{ `№ ${settings.id} ${auctionContent.title} ` }}</h5>
      <p class="mb-0">
        {{ $t('auction.expired_in') }}: {{ settings.activeTo | dateFormatter('DD-MM-YY HH:mm') }}
      </p>
      <p class="mb-0">
        {{ $t('auction.prize_expiry') }}: {{ settings.ttl }} {{ $t('common.days') }}
      </p>
    </div>
    <div class="card-body">
      <SellerView
        v-if="user.role === 'SELLER'"
        :categories="categories"
        :settings="settings"
        :auction-content="auctionContent"
        @changePrize="(payload) => $emit('changePrize', payload)"
      />
      <AdminView
        v-else-if="user.role === 'ADMIN'"
        :categories="categories"
        :settings="settings"
        :auction-content="auctionContent"
        @delete="$emit('delete')"
        @setWinner="(payload) => $emit('setWinner', payload)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SellerView from './SellerView.vue'
import AdminView from './AdminView.vue'
export default {
  name: 'FinishedAuction',
  components: {
    SellerView,
    AdminView,
  },
  props: {
    categories: {
      type: Array,
      default: () => {},
    },
    settings: {
      type: Object,
      default: () => {},
    },
    auctionContent: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
    }),
  },
}
</script>
